import http from './http';

const apiBaseUrl = String(process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '');

export const getPublicH5Page = (plateNo, silent = false) => http.get('/api/public/h5-page', {
  params: {plateNo},
  silent
});

export const lookupMerchantForBinding = merchantNo => http.get(
  '/api/public/merchant-binding/lookup',
  {params: {merchantNo}}
);

export const bindPlateToStore = data => http.post('/api/public/merchant-binding/bind', data);

export const createMerchantAndBindPlate = data => http.post(
  '/api/public/merchant-binding/create-and-bind',
  data
);

export const drawShareContent = plateNo => http.post(
  '/api/public/h5-page/share-content',
  null,
  {params: {plateNo}}
);

export const drawReviewContent = (
  plateNo, itemType, contentType, topicId, excludeId, randomAll = false
) => http.post(
  '/api/public/h5-page/review-content',
  null,
  {params: {plateNo, itemType, contentType, topicId, excludeId, randomAll}}
);

export const getPublicReviewTopics = plateNo => http.get(
  '/api/public/h5-page/review-topics',
  {params: {plateNo}}
);

export const markReviewUsed = (plateNo, reviewId, itemType, contentType) => http.post(
  `/api/public/h5-page/review-content/${encodeURIComponent(reviewId)}/use`,
  null,
  {params: {plateNo, itemType, contentType}}
);

export const getShareContentDownloadUrl = (plateNo, videoId) => (
  `${apiBaseUrl}/api/public/h5-page/share-content/${encodeURIComponent(videoId)}`
  + `/download?plateNo=${encodeURIComponent(plateNo)}`
  + `&mchId=${encodeURIComponent(window.sessionStorage.getItem('ai-video-public-mch-id') || '')}`
);

export const createDouyinPublishSchema = (plateNo, videoId) => http.post(
  '/api/public/h5-page/douyin-publish-schema',
  {plateNo, videoId}
);

export const createWechatMiniProgramScheme = (plateNo, action) => http.post(
  '/api/public/h5-page/wechat-mini-program-scheme',
  {plateNo, action}
);

export const createWechatMiniProgramHomeScheme = () => http.post(
  '/api/public/h5-page/wechat-mini-program-home-scheme'
);

export const createWechatMiniProgramClaimScheme = () => http.post(
  '/api/public/h5-page/wechat-mini-program-claim-scheme'
);
